import Vue from 'vue'
import Router from 'vue-router'
import Skills from './components/Skills.vue'
import About from './components/About.vue'  
import Calculator from './components/Calculator.vue'
import Notes from './components/notes.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'skills',
      component: Skills
    },
    {
      path: '/about/:name',
      name: 'about',
      component: About
    },
    {
      path: '/calculator',
      name: 'calculator',
      component: Calculator
    },
    {
      path: '/notes',
      name: 'notes',
      component: Notes
    },
  ]
})


// WEBPACK FOOTER //
// ./src/router.js